export default "__VITE_ASSET__PLSTN5Xp__"